var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasRpc
    ? _c(
        "PortalWidget",
        {
          attrs: {
            widget: { title: _vm.computedTitle, iconClass: "fa fa-gear" }
          },
          scopedSlots: _vm._u(
            [
              !_vm.showSpecificRecordDetails
                ? {
                    key: "headerContent",
                    fn: function() {
                      return [
                        _c("div", { staticClass: "header-extra" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters.name.value,
                                expression: "filters.name.value"
                              }
                            ],
                            staticClass:
                              "form-control input-md widget-header-input m-r-10",
                            attrs: {
                              type: "search",
                              placeholder: _vm.$t("SEARCH_PREDICTIVE_ROUTING")
                            },
                            domProps: { value: _vm.filters.name.value },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.filters.name,
                                  "value",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          )
        },
        [
          _vm._v(" "),
          !_vm.loading
            ? _c("div", { staticClass: "m-t-10 m-b-15" }, [
                !_vm.showSpecificRecordDetails
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-success btn-sm m-r-5",
                        attrs: { type: "button", disabled: _vm.showCreateForm },
                        on: { click: _vm.displayCreateForm }
                      },
                      [
                        _c("i", { staticClass: "fa fa-plus" }),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "BUTTON_CREATE_PREDICTIVE_ROUTING",
                              expression: "'BUTTON_CREATE_PREDICTIVE_ROUTING'"
                            }
                          ]
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSpecificRecordDetails
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-default btn-sm",
                        attrs: {
                          "ui-sref": "dashboard.predictive-routing",
                          href: "#/dashboard/predictive-routing"
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-arrow-left" }),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "RPC_PREDICTIVE_ROUTING_SHOW_ALL",
                              expression: "'RPC_PREDICTIVE_ROUTING_SHOW_ALL'"
                            }
                          ]
                        })
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                { staticClass: "grid_table_holder" },
                [
                  _c(
                    "v-table",
                    {
                      staticClass: "table_beauty",
                      attrs: {
                        data: _vm.predictiveRouting,
                        "current-page": _vm.currentPage,
                        filters: _vm.filters,
                        "page-size": 20,
                        "hide-sort-icons": true
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        totalPagesChanged: function($event) {
                          _vm.totalPages = $event
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "body",
                            fn: function({ displayData }) {
                              return _c(
                                "tbody",
                                {},
                                [
                                  !_vm.showCreateForm &&
                                  !_vm.predictiveRouting.length
                                    ? _c("tr", [
                                        _c("td", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value: "PREDICTIVE_ROUTING_EMPTY",
                                              expression:
                                                "'PREDICTIVE_ROUTING_EMPTY'"
                                            }
                                          ],
                                          attrs: { colspan: "100" }
                                        })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showCreateForm
                                    ? _c(
                                        "tr",
                                        {
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("ERPCSettingsForm", {
                                                attrs: {
                                                  "current-predictive-routing-config":
                                                    _vm.predictiveRoutingConfigToDuplicate,
                                                  "show-loader":
                                                    _vm
                                                      .createPredictiveRoutingConfigStatus
                                                      .status === "pending",
                                                  "is-table-view": true
                                                },
                                                on: {
                                                  submit:
                                                    _vm.createPredictiveRouting,
                                                  cancel: _vm.hideCreateForm
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(displayData, function(row, index) {
                                    return [
                                      !(
                                        _vm.isMobile &&
                                        _vm.activeActionRowId == row.id
                                      )
                                        ? _c(
                                            "tr",
                                            {
                                              key: row.id,
                                              class: {
                                                "bg-row-odd": index % 2 === 0,
                                                "bg-row-even": index % 2 !== 0
                                              }
                                            },
                                            [
                                              _vm.isMobile
                                                ? _c("td", [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-list-function btn-expand-actions",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.displayMobileAction(
                                                              row.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-ellipsis-v"
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: `#/dashboard/predictive-routing/${row.id}`
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayEditForm(
                                                          row.id,
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(row.name) +
                                                        "\n              "
                                                    )
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.configType(row)
                                                    ) +
                                                    "\n            "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              !_vm.isMobile
                                                ? _c(
                                                    "td",
                                                    [
                                                      _c(
                                                        "PredictiveRoutingActions",
                                                        {
                                                          attrs: {
                                                            "current-predictive-routing": row,
                                                            disabled:
                                                              _vm.disabled
                                                          },
                                                          on: {
                                                            deletePredictiveRouting:
                                                              _vm.confirmDeletePredictiveRouting,
                                                            editPredictiveRouting: function(
                                                              $event
                                                            ) {
                                                              return _vm.displayEditForm(
                                                                row.id
                                                              )
                                                            },
                                                            duplicatePredictiveRouting: function(
                                                              $event
                                                            ) {
                                                              return _vm.duplicatePredictiveRouting(
                                                                row.id
                                                              )
                                                            },
                                                            showPredictiveRoutingReferences: function(
                                                              $event
                                                            ) {
                                                              return _vm.displayReferences(
                                                                row.id
                                                              )
                                                            }
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isMobile &&
                                      _vm.activeActionRowId == row.id
                                        ? _c(
                                            "tr",
                                            {
                                              key: row.id + "-mobile",
                                              staticClass:
                                                "mobile-actions slide-right"
                                            },
                                            [
                                              _c(
                                                "td",
                                                { attrs: { colspan: "10" } },
                                                [
                                                  _c(
                                                    "PredictiveRoutingActions",
                                                    {
                                                      attrs: {
                                                        "current-predictive-routing": row,
                                                        disabled: _vm.disabled
                                                      },
                                                      on: {
                                                        deletePredictiveRouting:
                                                          _vm.confirmDeletePredictiveRouting,
                                                        collapseActions: function(
                                                          $event
                                                        ) {
                                                          !_vm.disabled &&
                                                            _vm.hideMobileAction()
                                                        },
                                                        editPredictiveRouting: function(
                                                          $event
                                                        ) {
                                                          return _vm.displayEditForm(
                                                            row.id
                                                          )
                                                        },
                                                        duplicatePredictiveRouting: function(
                                                          $event
                                                        ) {
                                                          return _vm.duplicatePredictiveRouting(
                                                            row.id
                                                          )
                                                        },
                                                        showPredictiveRoutingReferences: function(
                                                          $event
                                                        ) {
                                                          return _vm.displayReferences(
                                                            row.id
                                                          )
                                                        }
                                                      }
                                                    }
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showEditForm(row.id)
                                        ? _c(
                                            "tr",
                                            {
                                              key: row.id + "-edit",
                                              staticClass:
                                                "row-inline-new-form slide-down bg-row-even"
                                            },
                                            [
                                              _c(
                                                "td",
                                                { attrs: { colspan: "100" } },
                                                [
                                                  _c("ERPCSettingsForm", {
                                                    attrs: {
                                                      "show-loader":
                                                        _vm
                                                          .updatePredictiveRoutingConfigStatus
                                                          .status == "pending",
                                                      "current-predictive-routing-config": row,
                                                      "is-new-config": false,
                                                      "is-table-view": true
                                                    },
                                                    on: {
                                                      submit:
                                                        _vm.updatePredictiveRouting,
                                                      cancel: _vm.hideEditForm
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            }
                          }
                        ],
                        null,
                        false,
                        2226422210
                      )
                    },
                    [
                      _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                        _c(
                          "tr",
                          [
                            _vm.isMobile ? _c("th") : _vm._e(),
                            _vm._v(" "),
                            _c("v-th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "TABLE_COL_NAME",
                                  expression: "'TABLE_COL_NAME'"
                                }
                              ],
                              attrs: {
                                "default-sort": "asc",
                                "sort-key": "name"
                              }
                            }),
                            _vm._v(" "),
                            _c("v-th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "TABLE_COL_TYPE",
                                  expression: "'TABLE_COL_TYPE'"
                                }
                              ],
                              attrs: {
                                "default-sort": "asc",
                                "sort-key": "type"
                              }
                            }),
                            _vm._v(" "),
                            !_vm.isMobile
                              ? _c("th", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "TABLE_COL_ACTIONS",
                                      expression: "'TABLE_COL_ACTIONS'"
                                    }
                                  ]
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.predictiveRouting && _vm.predictiveRouting.length
                    ? _c("div", { staticClass: "pagination-min" }, [
                        _c(
                          "div",
                          { staticClass: "text-center p-7" },
                          [
                            _c("smart-pagination", {
                              attrs: {
                                "current-page": _vm.currentPage,
                                "total-pages": _vm.totalPages,
                                "max-page-links": 7
                              },
                              on: {
                                "update:currentPage": function($event) {
                                  _vm.currentPage = $event
                                },
                                "update:current-page": function($event) {
                                  _vm.currentPage = $event
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "text-center empty-records" },
                [
                  _c("Loader"),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PREDICTIVE_ROUTING_TABLE_LOADING",
                        expression: "'PREDICTIVE_ROUTING_TABLE_LOADING'"
                      }
                    ]
                  })
                ],
                1
              ),
          _vm._v(" "),
          _vm.showConfirmation
            ? _c("PredictiveRoutingConfigDeleteModalBasic", {
                attrs: {
                  "predictive-routing-config":
                    _vm.predictiveRoutingConfigToDelete,
                  "disable-modal-confirm": _vm.disableModalConfirm,
                  "deleting-predictive-routing-config":
                    _vm.deletingPredictiveRoutingConfig,
                  references: _vm.references,
                  "has-references": _vm.hasReferences,
                  "config-delete-force": _vm.predictiveRoutingConfigDeleteForce
                },
                on: {
                  "update:configDeleteForce": function($event) {
                    _vm.predictiveRoutingConfigDeleteForce = $event
                  },
                  "update:config-delete-force": function($event) {
                    _vm.predictiveRoutingConfigDeleteForce = $event
                  },
                  closeModal: _vm.closeModal,
                  attestDelete: _vm.attestDelete,
                  deletePredictiveRoutingConfig: _vm.deletePredictiveRouting
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }